export default __webpack_public_path__ + "static/media/nyc.74a204a9.jpg";